export const catalog_matrix = [
    {form_key:'user_level_id', catalog_key:'user_levels'},
    {form_key:'timezone', catalog_key:'timezones'},
    {form_key:'employee_status_id', catalog_key:'user_status'},
  ]